[
  {
    "draftJersey": 107,
    "role": "PT",
    "name": "Andrea Navarro",
    "foot": "right",
    "height": 164,
    "birthdate": "18/02/1998",
    "country": "España",
    "macros": {
      "reflexes": 72,
      "diving": 78,
      "duels": 81,
      "passing": 82,
      "handling": 79,
      "anticipation": 81,
      "average": 78
    },
    "matchYtVideoId": "z7Osz1N5VnI",
    "profileYtVideoId": "kHMjV26ckxs",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/292118908.png"
  },
  {
    "draftJersey": 130,
    "role": "PT",
    "name": "Gemma Rodríguez",
    "foot": "right",
    "height": 171,
    "birthdate": "27/03/1996",
    "country": "España",
    "macros": {
      "reflexes": 77,
      "diving": 77,
      "duels": 82,
      "passing": 60,
      "handling": 79,
      "anticipation": 73,
      "average": 77
    },
    "matchYtVideoId": "Jn5TULMJhgY",
    "profileYtVideoId": "JLl09bZJPuM",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/898476307.png"
  },
  {
    "draftJersey": 381,
    "role": "PT",
    "name": "Inés Ruiz",
    "foot": "right",
    "height": 158,
    "birthdate": "05/10/1998",
    "country": "España",
    "macros": {
      "reflexes": 81,
      "diving": 87,
      "duels": 87,
      "passing": 75,
      "handling": 83,
      "anticipation": 79,
      "average": 83
    },
    "matchYtVideoId": "IY9qBkPSrpA",
    "profileYtVideoId": "07LXbAU6_xU",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/932432534.png"
  },
  {
    "draftJersey": 168,
    "role": "PT",
    "name": "Laia Cutillas",
    "foot": "right",
    "height": 160,
    "birthdate": "21/10/2004",
    "country": "España",
    "macros": {
      "reflexes": 81,
      "diving": 86,
      "duels": 82,
      "passing": 77,
      "handling": 79,
      "anticipation": 79,
      "average": 81
    },
    "matchYtVideoId": "x-2FfPAk0UI",
    "profileYtVideoId": "VCWJDmDJ4FI",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/664559804.png"
  },
  {
    "draftJersey": 171,
    "role": "PT",
    "name": "Lydia Pérez",
    "foot": "right",
    "height": 167,
    "birthdate": "11/04/2000",
    "country": "España",
    "macros": {
      "reflexes": 80,
      "diving": 80,
      "duels": 76,
      "passing": 78,
      "handling": 79,
      "anticipation": 80,
      "average": 79
    },
    "matchYtVideoId": "x-2FfPAk0UI",
    "profileYtVideoId": "8zDCOYi9upg",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/562092138.png"
  },
  {
    "draftJersey": 173,
    "role": "PT",
    "name": "Mar Sánchez",
    "foot": "right",
    "height": 170,
    "birthdate": "18/02/2003",
    "country": "España",
    "macros": {
      "reflexes": 78,
      "diving": 85,
      "duels": 81,
      "passing": 76,
      "handling": 80,
      "anticipation": 82,
      "average": 80
    },
    "matchYtVideoId": "8NTn2hEkJkk",
    "profileYtVideoId": "sorwxgg9Hhw",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/634951417.png"
  },
  {
    "draftJersey": 193,
    "role": "PT",
    "name": "Mireia Asensio",
    "foot": "right",
    "height": 154,
    "birthdate": "27/03/1996",
    "country": "España",
    "macros": {
      "reflexes": 82,
      "diving": 82,
      "duels": 82,
      "passing": 66,
      "handling": 68,
      "anticipation": 74,
      "average": 76
    },
    "matchYtVideoId": "61CbJ-9wS1Q",
    "profileYtVideoId": "t3Ntyh4Jl7s",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/533373646.png"
  },
  {
    "draftJersey": 209,
    "role": "PT",
    "name": "Sheila Artigas",
    "foot": "right",
    "height": 162,
    "birthdate": "13/06/1997",
    "country": "España",
    "macros": {
      "reflexes": 75,
      "diving": 80,
      "duels": 78,
      "passing": 75,
      "handling": 78,
      "anticipation": 75,
      "average": 77
    },
    "matchYtVideoId": "61CbJ-9wS1Q",
    "profileYtVideoId": "MjB2vUnm-LQ",
    "imageUrl": "https://s3.eu-central-2.wasabisys.com/kingsleague-cdn.kama.football/account/production/player/280683925.png"
  }
]